<template>
  <div>
    <!-- Primary Meta Tags -->
    <meta name="description" :content="description" v-if="description">
    <meta name="keywords" :content="keywords" v-if="keywords">
    <meta name="author" content="KAMS LED">
    <meta name="robots" content="index, follow">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    
    <!-- Open Graph / Facebook -->
    <meta property="og:type" content="website">
    <meta property="og:url" :content="fullCanonicalUrl">
    <meta property="og:title" :content="title" v-if="title">
    <meta property="og:description" :content="description" v-if="description">
    <meta property="og:image" :content="image" v-if="image">
    <meta property="og:site_name" content="KAMS LED">
    
    <!-- Twitter -->
    <meta name="twitter:card" content="summary_large_image">
    <meta name="twitter:url" :content="fullCanonicalUrl">
    <meta name="twitter:title" :content="title" v-if="title">
    <meta name="twitter:description" :content="description" v-if="description">
    <meta name="twitter:image" :content="image" v-if="image">
    
    <!-- Canonical URL -->
    <link rel="canonical" :href="fullCanonicalUrl">
    
    <!-- Structured Data -->
    <script type="application/ld+json" v-html="structuredDataString"></script>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
    keywords: String,
    canonicalUrl: String,
    image: String,
    structuredData: Object
  },
  computed: {
    // 确保canonicalUrl是完整URL
    fullCanonicalUrl() {
      if (!this.canonicalUrl) return window.location.href;
      
      // 如果已经是完整URL，直接返回
      if (this.canonicalUrl.startsWith('http://') || this.canonicalUrl.startsWith('https://')) {
        return this.canonicalUrl;
      }
      
      // 否则拼接完整URL
      const baseUrl = window.location.origin;
      return `${baseUrl}${this.canonicalUrl}`;
    },
    // 将structuredData对象转换为JSON字符串
    structuredDataString() {
      try {
        if (this.structuredData && typeof this.structuredData === 'object') {
          return JSON.stringify(this.structuredData);
        }
        return JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": this.title || '',
          "description": this.description || '',
          "url": this.fullCanonicalUrl
        });
      } catch (error) {
        console.error('Error formatting structured data:', error);
        return '{}';
      }
    }
  },
  // 确保页面标题也被设置
  created() {
    if (this.title) {
      document.title = this.title;
    }
  }
}
</script>